import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "modify" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")
  const _component_el_dropdown = _resolveComponent("el-dropdown")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_dropdown, {
      class: "dropdown pointer",
      "split-button": "",
      style: {"margin-left":"auto"},
      placement: "top",
      trigger: "click",
      teleported: false,
      size: "large",
      "popper-class": "chats-dropdown-edit",
      onVisibleChange: _cache[0] || (_cache[0] = $event => ($data.visible = $event)),
      onClick: _cache[1] || (_cache[1] = $event => (_ctx.$emit('toggle-add')))
    }, {
      dropdown: _withCtx(() => [
        _createVNode(_component_el_dropdown_menu, null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.ROLES, (action) => {
              return (_openBlock(), _createBlock(_component_el_dropdown_item, {
                key: action.role,
                class: "item",
                onClick: $event => (_ctx.$emit('add', action))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(action.role), 1 /* TEXT */)
                ]),
                _: 2 /* DYNAMIC */
              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]))
            }), 128 /* KEYED_FRAGMENT */))
          ]),
          _: 1 /* STABLE */
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_Icon, {
          icon: "plus",
          width: "2rem",
          height: "2rem",
          stroke: "var(--base-white)"
        }),
        _cache[2] || (_cache[2] = _createTextVNode(" Message "))
      ]),
      _: 1 /* STABLE */
    })
  ]))
}